import axios from '@/utils/api.request'
let previousUrl = '/api'

export const getBackupManList = (pageSize, pageNumber) => {
  return axios.request({
    url: `${previousUrl}/BackupMan/list?page=${pageNumber}&size=${pageSize}&sort=Id,desc`,
    method: 'get'
  })
}

export const addBackupMan = (data) => {
  return axios.request({
    url: `${previousUrl}/BackupMan/add`,
    params: data,
    method: 'get'
  })
}

export const updateBackupMan = (data) => {
  return axios.request({
    url: `${previousUrl}/BackupMan/update`,
    data: data,
    method: 'post'
  })
}

export const enableBackupMan = (data) => {
  return axios.request({
    url: `${previousUrl}/BackupMan/enable/${data.id}`,
    data: data,
    method: 'post'
  })
}

export const diabledBackupMan = (data) => {
  return axios.request({
    url: `${previousUrl}/BackupMan/disable/${data.id}`,
    data: data,
    method: 'post'
  })
}
